<template>
    <div class="ability-display mt-3">
        <div
            class="d-flex justify-content-between align-items-center mb-2 flex-wrap"
        >
            <h4 class="m-0">Abilities</h4>
            <router-link
                :to="`/ability-tree/${characterId}`"
                class="btn btn-primary"
            >
                <font-awesome-icon icon="pen-to-square" class="me-1" />Manage
            </router-link>
        </div>

        <!-- Background ability -->
        <div
            v-if="character.background"
            class="text-center"
            @click="openModal(character.background.ability, true)"
        >
            <hr />
            Background Ability: {{ character.background.ability }}
            <hr />
        </div>

        <!-- Character abilities -->
        <div v-for="(ability, index) in [...abilities].reverse()" :key="ability.id">
            <div class="row">
                <div
                    class="col-sm-12 d-flex justify-content-between align-items-center"
                    @click="openModal(ability, false)"
                >
                    <div
                        class="ability-card d-flex justify-content-between align-items-center"
                    >
                        <strong class="me-1">{{ ability.name }} - </strong>
                        <div class="text-sm">Tier: {{ ability.tier }}</div>
                    </div>
                    <img
                        :src="getAbilityImage(ability.requiredStat)"
                        :alt="ability.name"
                        class="rounded-3 d-none d-md-block"
                        style="max-width: 2rem"
                    />
                </div>
                <hr v-if="index < abilities.length - 1" />
            </div>
        </div>

        <!-- Bootstrap Modal -->
        <div
            class="modal fade"
            id="abilityModal"
            tabindex="-1"
            aria-hidden="true"
            ref="abilityModal"
        >
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div
                    class="modal-content bg-dark text-light rounded-3 shadow-lg"
                >
                    <div class="modal-header border-secondary">
                        <h4 class="modal-title" v-if="selectedAbility">
                            {{ selectedAbility.name }}
                            <small v-if="selectedAbility.tier"
                                >(Tier: {{ selectedAbility.tier }})</small
                            >
                        </h4>
                        <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            @click="closeModal"
                        ></button>
                    </div>
                    <div class="modal-body" v-if="selectedAbility">
                        <div class="row">
                            <div
                                class="col-sm-6"
                                v-if="selectedAbility.archetype"
                            >
                                <strong>Archetype:</strong>
                                {{ selectedAbility.archetype }}
                            </div>
                            <div
                                class="col-sm-6 text-end"
                                v-if="selectedAbility.path"
                            >
                                <strong>Path:</strong>
                                {{
                                    selectedAbility.path === "None"
                                        ? "All"
                                        : selectedAbility.path
                                }}
                            </div>
                            <div class="col-sm-12 mt-3">
                                <p>{{ selectedAbility.description }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-bs-dismiss="modal"
                            @click="closeModal"
                        >
                            <font-awesome-icon
                                icon="multiply"
                                class="me-1"
                            />Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from "bootstrap";
import { useRosterStore } from "../stores/index";

export default {
    name: "AbilityDisplay",
    props: {
        abilities: {
            type: Array,
            default: () => [],
        },
        characterId: {
            type: Number,
            required: true,
        },
        theme: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            selectedAbility: null,
            modalInstance: null,
            character: {},
        };
    },
    methods: {
        async fetchCharacter() {
            const store = useRosterStore();
            try {
                this.character = await store.getCharacterById(this.characterId);
            } catch (error) {
                console.error("Failed to fetch character", error);
            }
        },
        getAbilityImage(stat) {
            if (!stat || stat.toLowerCase() === "none") stat = "survivor";
            return require(`@/../public/img/${stat}${this.theme}.png`);
        },
        openModal(ability, isBackground = false) {
            if (isBackground) {
                this.selectedAbility = {};
                this.selectedAbility.name = ability;
                this.selectedAbility.tier = "Background";
                this.selectedAbility.archetype = this.character.archetype;
                this.selectedAbility.path = "None";
                this.selectedAbility.description =
                    this.character.background.abilityDescription;
            } else {
                this.selectedAbility = ability;
            }
            if (!this.modalInstance) {
                this.modalInstance = new Modal(this.$refs.abilityModal);
            }
            this.modalInstance.show();
        },
        closeModal() {
            this.selectedAbility = null;
            if (this.modalInstance) this.modalInstance.hide();
        },
    },
    created() {
        this.fetchCharacter();
    },
    watch: {
        characterId: "fetchCharacter",
    },
};
</script>

<style scoped>
.ability-display {
    padding: 10px 5px;
    border: solid 2px #555;
    border-radius: 8px;
}

.ability-card {
    padding: 8px;
    /* margin-bottom: 6px; */
    cursor: pointer;
    transition: background 0.2s;
}
</style>

